import * as React from "react";
const SvgPerspective = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M13 23V11.5L23 6L18 19L13 23Z", fill: "#232729" }), /* @__PURE__ */ React.createElement("path", { d: "M11 11.5L1 6L6 19L11 23V11.5Z", fill: "#232729" }), /* @__PURE__ */ React.createElement("path", { d: "M12 10L2 5L12 1L22 5L12 10Z", fill: "#232729" }));
export default SvgPerspective;
